export default "__VITE_ASSET__DuB94Ydc__"